/**
 * Statutory Year-End Close, Financial Statements & Notes Module (`web/src/lib/copy.ts`).
 *
 * @statutory OR Art. 958–960e (Geschäftsbericht, Bilanz, Erfolgsrechnung, Anhang & Bewertung) · OR Art. 963–963b (Konzernrechnung) · OR Art. 725–725b (Kapitalverlust & Überschuldung) · HWP & Swiss GAAP FER
 */
/**
 * Click-to-copy on every read-only data surface — one delegated handler for the whole app.
 * Surfaces: any table inside [data-copy-surface] (cell granularity) and any [data-copy-unit].
 */
const INTERACTIVE = 'a, button, input, textarea, [role="button"], [role="option"], label, summary';

async function write(text: string) {
  try { await navigator.clipboard.writeText(text); return true; } catch { /* fall through */ }
  const ta = document.createElement('textarea');
  ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
  document.body.appendChild(ta); ta.select();
  let ok = false;
  try { ok = document.execCommand('copy'); } catch { ok = false; }
  ta.remove();
  return ok;
}

function pill(x: number, y: number, label: string) {
  const el = document.createElement('div');
  el.className = 'copy-pill'; el.textContent = label; el.style.left = `${x}px`; el.style.top = `${y}px`;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 1000);
  const sr = document.getElementById('sr-status');
  if (sr) sr.textContent = label;
}

export function installCopy() {
  document.addEventListener('click', async (e) => {
    const target = e.target as HTMLElement;
    if (!target?.closest || target.closest(INTERACTIVE)) return;
    const unit = (target.closest('[data-copy-unit]') ?? target.closest('[data-copy-surface] td')) as HTMLElement | null;
    if (!unit || unit.hasAttribute('data-no-copy')) return;
    const sel = window.getSelection();
    if (sel && !sel.isCollapsed && sel.toString().trim()) return;
    const text = (unit.getAttribute('data-copy-value') ?? unit.innerText).split('\n').map((l) => l.trim()).filter(Boolean).join('\n');
    if (!text || text === '—') return;
    const ok = await write(text);
    unit.classList.remove('copy-flash'); void unit.offsetWidth; unit.classList.add('copy-flash');
    pill(e.clientX, e.clientY, ok ? 'Kopiert' : 'Kopieren fehlgeschlagen');
  });
}
